// extracted by mini-css-extract-plugin
export var questionBox = "_79-0";